import DashboardLayout from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Mail, Phone, MessageSquare } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function HelpCentre() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/cms/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Help Centre</div>
          <h1 className="font-display text-3xl mt-2">We're here to help</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card className="p-5 card-hover"><Mail className="h-5 w-5 text-primary" /><div className="font-display text-lg mt-3">Email</div><div className="text-sm text-muted-foreground">hello@finzpe.com</div></Card>
          <Card className="p-5 card-hover"><Phone className="h-5 w-5 text-primary" /><div className="font-display text-lg mt-3">Phone</div><div className="text-sm text-muted-foreground">+91 87000 59442</div></Card>
          <Card className="p-5 card-hover"><MessageSquare className="h-5 w-5 text-primary" /><div className="font-display text-lg mt-3">Live Chat</div><div className="text-sm text-muted-foreground">Bottom-right of any page</div></Card>
        </div>
        <Card className="p-6">
          <div className="font-display text-xl mb-4">Frequently asked</div>
          <Accordion type="single" collapsible>
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`h-${i}`}><AccordionTrigger>{f.q}</AccordionTrigger><AccordionContent className="text-muted-foreground">{f.a}</AccordionContent></AccordionItem>
            ))}
          </Accordion>
        </Card>
      </div>
    </DashboardLayout>
  );
}
